import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import "./navbar.css";
import rs_logo from "../../assets/images/roadsense_logo.png";
import rs_logo_full from "../../assets/images/roadsense_logo_full.png";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, db, logout } from "../../firebase";
import { query, collection, getDocs, where } from "firebase/firestore";
import { BiHomeAlt } from "react-icons/bi";
import { BsBarChart } from "react-icons/bs";
import { MdOutlineAccountCircle } from "react-icons/md";
import { PiGearSixFill } from "react-icons/pi";
import { IoMdLogOut } from "react-icons/io";



const NavbarLanding = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setName(data.name);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserName();
  }, [user, loading]);

  return (
    <nav className="navbar_landing">
      
      <div className="container-navbar">
          <NavLink to="/" className="navbar-items index_logo">
            <img className="navbar-logo" src={rs_logo_full}></img>
          </NavLink>

        <div className="navbar-items nav-elements">
          <NavLink 
            className="nav-elements-ind"
             to="/dashboard"
          >
            <div>
              {/* <BiHomeAlt size={35} className="icon-1"/>
              <p className="tooltiptext">LEARN</p> */}
              LEARN
            </div>
          </NavLink>

          <NavLink 
            className="nav-elements-ind"
            to="/progress"        
          >
            <div>
              {/* <BsBarChart size={35} className="icon-1"/>
              <p className="tooltiptext">PROGRESS</p> */}
              PROGRESS
            </div>
          </NavLink>

          <NavLink 
            className="nav-elements-ind"
            to="/profile"
          >
            <div>
              {/* <MdOutlineAccountCircle size={35} className="icon-1"/>
              <p className="tooltiptext">PROFILE</p> */}
              PROFILE
            </div>

          </NavLink>
        </div>

        <div className="navbar-items setting-button-width">
            {/* <button className="button-17" onClick={logout}>
              LOG OUT
            </button> */}
            <p>Logout</p>
            <Link onClick={logout} className="setting-icon-bg">
              <IoMdLogOut size={40} className="setting-icon"/>
            </Link>
        </div>

      </div>
    </nav>
  );
};

export default NavbarLanding;
